import { IParameters } from "@core/services/interfaces/oldService/IOldService";
import { IMonth, IEffectivateBillingState } from "./effectivateBillingState";

export default {
  monthsOptions: (state: IEffectivateBillingState): IMonth[] => {
    return state.months;
  },
};
